import { render } from "./ProgramDescription.vue?vue&type=template&id=2c90edab"
import script from "./ProgramDescription.vue?vue&type=script&lang=js"
export * from "./ProgramDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__